import React, { memo, useCallback, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TreeSelect, Upload, Button as AntButton } from "antd";
import {
  UploadOutlined,
  FileTextOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import RichEditor from "../../components/RichEditor/RichEditor";
import "./TreeSelectStyled.scss";
import { useFormik } from "formik";
import utils from "../../utils";
import { ASSIGNEE_TYPE, HH_mm, ISO_DATE_FORMAT } from "../../constants";
import PopupRenameFile from "../../components/PopupRenameFile/PopupRenameFile";
import * as yup from "yup";
import moment from "moment";
import {
  UploadFileListItem,
  UploadFileListWrapper,
} from "./CompanyWorkScheduleStyled";

const { SHOW_CHILD } = TreeSelect;

const CompanyWorkScheduleUpdate = (props) => {
  const {
    open,
    handleClose,
    departmentStore,
    authenticationStore,
    loadingAnimationStore,
    createMessage,
    fileStore,
    workScheduleStore,
    workScheduleDetail,
    setGetDetail,
  } = props;
  const { departmentList } = departmentStore;
  const { currentUser } = authenticationStore;
  const filterCurrentUserDepartmentList = toJS(departmentList).filter(
    (el) => el.value !== currentUser?.username
  );
  useEffect(() => {
    (async () => {
      try {
        loadingAnimationStore.showSpinner(true);
        await departmentStore.getDepartmentWithUsers(
          authenticationStore.currentCompanyCode()
        );
      } catch (err) {
        console.log(err);
        createMessage(err.vi || "Có lỗi xảy ra!", true, "error");
      } finally {
        loadingAnimationStore.showSpinner(false);
      }
    })();
  }, []);
  const handleCloseForm = () => {
    setGetDetail(true);
    handleClose();
    setNew_item([]);
    setArrRecipientNotice([]);
    setRemove_items([]);
    setFileListUpdate(workScheduleDetail.file_ids);
    workScheduleStore.getWorkScheduleDetail(workScheduleDetail?.schedule_code);
  };
  const [fileUploadedList, setFileListUpdate] = useState([]);
  const fileUploaded = fileUploadedList?.map((item) => item.file_id);
  const [advanceFilterSD, setAdvanceFilterSD] = useState();
  useEffect(() => {
    setFileListUpdate(workScheduleDetail?.file_ids);
  }, [workScheduleDetail]);

  const handleChangeStartDate = (value) => {
    setAdvanceFilterSD(value.$d);
    formik.setFieldValue("start_date", moment(value.$d).toISOString());
  };

  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const [START_AT, setSTART_AT] = useState("");

  useEffect(() => {
    setSTART_AT(
      `${moment(advanceFilterSD).format(ISO_DATE_FORMAT)} ${moment(
        startTime
      ).format(HH_mm)}`
    );
  }, [advanceFilterSD, startTime]);
  const [END_AT, setEND_AT] = useState("");
  useEffect(() => {
    setEND_AT(
      `${moment(advanceFilterSD).format(ISO_DATE_FORMAT)} ${moment(
        endTime
      ).format(HH_mm)}` || null
    );
  }, [advanceFilterSD, endTime]);

  useEffect(() => {
    formik.setFieldValue("start_at", moment(START_AT).toISOString());
    formik.setFieldValue(
      "end_at",
      END_AT ? moment(END_AT).toISOString() : null
    );
  }, [START_AT, END_AT]);

  const [FILE_IDS, setFILE_IDS] = useState([]);

  const [new_items, setNew_item] = useState([]);
  const [remove_items, setRemove_items] = useState([]);
  const [arrRecipientNotice, setArrRecipientNotice] = useState([]);
  const [recipientNoticeList, setRecipientNoticeList] = useState([]);
  const [value, setValue] = useState();
  useEffect(() => {
    setRecipientNoticeList(
      workScheduleDetail?.assignees &&
        toJS(workScheduleDetail?.assignees).filter(
          (el) => el.permission === ASSIGNEE_TYPE.FOLLOWER
        )
    );
    setValue(recipientNoticeList?.map((user) => user.assignee_code || null));
  }, [workScheduleDetail]);
  useEffect(() => {
    if (workScheduleDetail?.schedule_code) {
      if (workScheduleDetail?.file_ids.length) {
        setFILE_IDS(workScheduleDetail.file_ids.map((file) => file.file_id));
      }
    }
    setAdvanceFilterSD(workScheduleDetail?.start_at);

    setStartTime(workScheduleDetail?.start_at);
    setEndTime(workScheduleDetail?.end_at);
    workScheduleDetail?.schedule_code &&
      formik.setFieldValue("title", workScheduleDetail?.title);
    formik.setFieldValue("start_date", workScheduleDetail?.start_at);
    formik.setFieldValue("start_time", workScheduleDetail?.start_at);
    formik.setFieldValue(
      "end_time",
      workScheduleDetail?.end_at && workScheduleDetail?.end_at
    );
    formik.setFieldValue("host", workScheduleDetail?.host);
    formik.setFieldValue("assignees", workScheduleDetail?.assignees);
    formik.setFieldValue("is_notification_required", true);
    formik.setFieldValue("location", workScheduleDetail?.location);
    formik.setFieldValue("event_notice", workScheduleDetail?.event_notice);
    formik.setFieldValue("attenders", workScheduleDetail?.attenders);
    formik.setFieldValue("preparation", workScheduleDetail?.preparation);
  }, [workScheduleDetail?.schedule_code, workScheduleDetail]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      assignees: [],
      attenders: workScheduleDetail?.attenders,
      end_time: workScheduleDetail?.end_at,
      host: workScheduleDetail?.host,
      is_notification_required: true,
      location: workScheduleDetail?.location,
      preparation: workScheduleDetail?.preparation,
      start_date: workScheduleDetail?.start_at,
      start_time: workScheduleDetail?.start_at,
      title: workScheduleDetail?.title,
      start_at: workScheduleDetail?.start_at,
      end_at: workScheduleDetail?.end_at,
      file_ids: FILE_IDS,
      assign_person_update: { new_items: [], remove_items: [] },
      event_notice: workScheduleDetail?.event_notice,
      // recipient_notice: recipientNoticeList?.map(user => user.assignee_code),
      recipient_notice: [],
    },
    validationSchema: yup.object().shape({
      start_date: yup
        .string()
        .required("Vui lòng chọn ngày thực hiện!")
        .matches(/^(?=.*\S).+$/, "Vui lòng chọn ngày thực hiện!"),
      start_time: yup
        .string()
        .required("Vui lòng chọn thời gian bắt đầu!")
        .matches(/^(?=.*\S).+$/, "Vui lòng chọn thời gian bắt đầu"),
      host: yup
        .string()
        .required("Vui lòng nhập chủ trì!")
        .matches(/^(?=.*\S).+$/, "Vui lòng nhập chủ trì!"),
      location: yup
        .string()
        .required("Vui lòng nhập địa điểm!")
        .matches(/^(?=.*\S).+$/, "Vui lòng nhập địa điểm!"),
    }),
    onSubmit: async (values) => {
      try {
        loadingAnimationStore.showSpinner(true);
        workScheduleStore.updateWorkSchedule(
          workScheduleDetail?.schedule_code,
          values
        );
        // console.log('values', values)
        loadingAnimationStore.showSpinner(false);
        createMessage("Cập nhật sự kiện thành công!", true, "success");
      } catch (err) {
        console.log(err);
      } finally {
        handleCloseForm();
      }
    },
  });
  const handleChangeStartTime = (value) => {
    if (moment(formik.values.end_time?.$d).isAfter(moment(value.$d))) {
      setStartTime(value.$d);
      formik.setFieldValue("start_time", moment(value.$d).toISOString());
    } else {
      createMessage(
        "thời gian bắt đầu không thể muộn hơn thời gian kết thúc, xin vui lòng chọn lại !!!",
        true,
        "error"
      );
    }
  };

  const handleChangeEndTime = (value) => {
    if (moment(value.$d).isAfter(moment(formik.values.start_time?.$d))) {
      setEndTime(value.$d);
      formik.setFieldValue("end_time", moment(value.$d).toISOString());
    } else {
      createMessage(
        "thời gian kết thúc không thể sớm hơn thời gian bắt đầu, xin vui lòng chọn lại !!!",
        true,
        "error"
      );
    }
  };
  const handleResetForm = () => {
    formik.resetForm();
    setValue(recipientNoticeList?.map((user) => user.assignee_code || null));
    setFileList([]);
  };

  const [data, setData] = useState("");
  const [change, setChange] = useState(false);
  const handleChangeRecipientNotice = (values) => {
    setValue(values);
    setRemove_items([]);
    setNew_item([]);
    setArrRecipientNotice([]);

    setChange(true);
    // values
    //   ?.filter(el => !utils.isUpper(el))
    //   .map(code => {
    //     arrRecipientNotice.push({
    //       assignee_code: code,
    //       assignee_type: ASSIGNEE_TYPE.USER,
    //       permission: ASSIGNEE_TYPE.FOLLOWER,
    //     })
    //   })
  };
  useEffect(() => {
    value
      ?.filter((el) => !utils.isUpper(el))
      .map((code) => {
        arrRecipientNotice.push({
          assignee_code: code,
          assignee_type: ASSIGNEE_TYPE.USER,
          permission: ASSIGNEE_TYPE.FOLLOWER,
        });
      });
    if (change === true) {
      const assignPersonUpdate = [...recipientNoticeList];
      arrRecipientNotice.forEach((user) => {
        if (
          !assignPersonUpdate
            .map((el) => el.assignee_code + el.permission)
            .includes(user.assignee_code + user.permission)
        ) {
          // push new_items

          new_items.push({
            assignee_code: user.assignee_code,
            assignee_type: user.assignee_type,
            permission: user.permission,
          });
        }
      });
      assignPersonUpdate.forEach((user) => {
        if (
          !arrRecipientNotice
            .map((el) => el.assignee_code + el.permission)
            .includes(user.assignee_code + user.permission)
        ) {
          // push remove_items
          remove_items.push({
            assignee_code: user.assignee_code,
            assignee_type: user.assignee_type,
            permission: user.permission,
          });
        }
      });
    } else {
      const assignPersonUpdate = [];
      arrRecipientNotice.forEach((user) => {
        if (
          !assignPersonUpdate
            .map((el) => el.assignee_code + el.permission)
            .includes(user.assignee_code + user.permission)
        ) {
          // push new_items

          new_items.push({
            assignee_code: user.assignee_code,
            assignee_type: user.assignee_type,
            permission: user.permission,
          });
        }
      });
      assignPersonUpdate.forEach((user) => {
        if (
          !arrRecipientNotice
            .map((el) => el.assignee_code + el.permission)
            .includes(user.assignee_code + user.permission)
        ) {
          // push remove_items
          remove_items.push({
            assignee_code: user.assignee_code,
            assignee_type: user.assignee_type,
            permission: user.permission,
          });
        }
      });
    }
    if (change === false) {
      formik.setFieldValue("assign_person_update", {
        new_items: [],
        remove_items: [],
      });
    } else {
      formik.setFieldValue("assign_person_update", {
        new_items: new_items.filter(
          (el) => el.assignee_code !== currentUser?.username
        ),
        remove_items: remove_items.filter(
          (el) => el.assignee_code !== currentUser?.username
        ),
      });
    }
    formik.setFieldValue("assignee", undefined);
    formik.setFieldValue("recipient_notice", value);
  }, [value]);

  useEffect(() => {
    formik.setFieldValue("event_notice", data);
  }, [data]);

  const [fileList, setFileList] = useState([]);

  const handleChangeFile = useCallback((info) => {
    if (info.fileList.length === 0) {
      formik.setFieldValue("file_upload", undefined);
      setFileList([]);
      return;
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex((file) => file.name === elem.name) === index
    );
    setFileList(filteredFileList);
  }, []);

  const handleRemoveFileFromUploadList = useCallback(
    (fileUID) => {
      const newFileList = fileList.filter((file) => file.uid !== fileUID);
      setFileList(newFileList);
      if (newFileList.length === 0) {
        formik.setFieldValue("attachments", []);
      }
    },
    [fileList]
  );
  const handleRemoveFileUpdate = useCallback(
    (file_id) => {
      const newFileList = fileUploadedList.filter(
        (file) => file.file_id !== file_id
      );
      setFileListUpdate(newFileList);
    },
    [fileUploadedList]
  );
  const updateAttachments = useCallback(async () => {
    const uploadFileList = fileList.map((file) => file.originFileObj);
    const batchUploadArr = [];
    uploadFileList.forEach((file) => {
      const formData = new FormData();
      formData.append("file", file);
      batchUploadArr.push(fileStore.uploadFile(formData));
    });
    const response = await Promise.all(batchUploadArr);
    const res = response.map((response) => response.data.file_id);
    const file = res.concat(fileUploaded);
    formik.setFieldValue("file_ids", file);
  }, [fileList, fileUploadedList]);

  useEffect(() => {
    updateAttachments();
  }, [updateAttachments]);
  const [isRenameFileUpdate, setIsRenameFileUpdate] = useState(false);
  const [fileExt, setFileExt] = useState(undefined);
  const [fileTargetRename, setFileTargetRename] = useState(null);
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] =
    useState(false);
  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ["rename"],
      value: "",
    },
  ]);

  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ["rename"],
        value: utils.removeExtensionFile(file.name),
      },
    ]);
    setFileExt("." + utils.getExtensionFile(file.name));
    setFileTargetRename({
      ...file,
      index: index,
    });
    setIsModalVisibleRenameFile(true);
  };
  const handleOpenPopupRenameFileUpdate = (file, index) => {
    setFieldsRenameFile([
      {
        name: ["rename"],
        value: utils.removeExtensionFile(file.file_title),
      },
    ]);
    setFileExt("." + utils.getExtensionFile(file.file_title));
    setFileTargetRename({
      ...file,
      index: index,
    });
    setIsModalVisibleRenameFile(true);
  };
  const handleOpenPopupRenameNewFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ["rename"],
        value: utils.removeExtensionFile(file.name),
      },
    ]);
    setFileExt("." + utils.getExtensionFile(file.name));
    setFileTargetRename({
      ...file,
      index: index,
    });
    setIsModalVisibleRenameFile(true);
  };
  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });
  };
  const submitRenameFile = async (value) => {
    const index = fileTargetRename?.index;

    // Đổi tên file update
    if (isRenameFileUpdate) {
      await fileStore.handleRenameFile(
        fileTargetRename.file_id,
        value.rename + fileExt
      );
      const fileUpdateAfterRename = [...fileUploadedList];
      fileUpdateAfterRename[index].file_title = value.rename + fileExt;
      setFileListUpdate(fileUpdateAfterRename);
      setIsModalVisibleRenameFile(false);
      return;
    }
    // đổi tên file nhận từ thiết bị (file chưa ký)
    if (fileTargetRename.originFileObj) {
      const newFileList = [...fileList];
      newFileList[index].name = value.rename + fileExt;
      newFileList[index].originFileObj = renameFile(
        newFileList[index].originFileObj,
        newFileList[index].name
      );
      setFileList(newFileList);
      setIsModalVisibleRenameFile(false);
    }
    // đổi tên file nhận từ thiết bị (file đã ký)
    if (!fileTargetRename.originFileObj) {
      await fileStore.handleRenameFile(
        fileTargetRename.id,
        value.rename + fileExt
      );
      setIsModalVisibleRenameFile(false);
      const newFileList = [...fileList];
      newFileList[index].name = value.rename + fileExt;
      setFileList(newFileList);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseForm}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100vw",
            maxWidth: "100vw",
            mx: 0,
            zIndex: 50,
          },
        },
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#ffffff] "
          sx={{
            fontWeight: 700,
            backgroundColor: "#2C65AC",
          }}
        >
          <span className="font-bold">Cập nhật sự kiện</span>
        </DialogTitle>
        <DialogContent>
          <div style={{ marginTop: 12 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="start_date"
                label={
                  <>
                    <span
                      style={{
                        display: "inline-block",
                        color: "#ff4d4f",
                        fontSize: "14px",
                        fontFamily: "SimSun,sans-serif",
                        lineHeight: 1,
                      }}
                    >
                      *
                    </span>
                    <span> Ngày thực hiện</span>
                  </>
                }
                openTo="day"
                // views={["day", "month", "year"]}
                // value={advanceFilterSD}
                value={formik.values.start_date}
                onChange={handleChangeStartDate}
                inputFormat="DD/MM/YYYY"
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                    }}
                    {...params}
                    error={
                      formik.errors.start_date && formik.touched.start_date
                        ? true
                        : false
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div style={{ marginTop: 12 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <TimePicker
                name="start_at"
                label={
                  <>
                    <span
                      style={{
                        display: "inline-block",
                        color: "#ff4d4f",
                        fontSize: "14px",
                        fontFamily: "SimSun,sans-serif",
                        lineHeight: 1,
                      }}
                    >
                      *
                    </span>
                    <span> Thời gian bắt đầu</span>
                  </>
                }
                views={["hours", "minutes"]}
                value={formik.values.start_time}
                onChange={handleChangeStartTime}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                    }}
                    {...params}
                    error={
                      formik.errors.start_time && formik.touched.start_time
                        ? true
                        : false
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div style={{ marginTop: 12 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <TimePicker
                name="end_at"
                label={
                  <>
                    <span> Thời gian kết thúc</span>
                  </>
                }
                views={["hours", "minutes"]}
                value={formik.values.end_time}
                onChange={handleChangeEndTime}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                    }}
                    {...params}
                    error={false}
                    placeholder="-- Chọn giờ kết thúc --"
                  />
                )}
              />
            </LocalizationProvider>
          </div>

          <div style={{ marginTop: 10 }}>
            <TextField
              name="host"
              id="standard-basic"
              label={
                <>
                  <span
                    style={{
                      display: "inline-block",
                      color: "#ff4d4f",
                      fontSize: "14px",
                      fontFamily: "SimSun,sans-serif",
                      lineHeight: 1,
                    }}
                  >
                    *
                  </span>
                  <span> Chủ trì</span>
                </>
              }
              value={formik.values.host}
              variant="standard"
              sx={{ textAlign: "center", height: "56px", width: "100%" }}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              error={formik.errors.host && formik.touched.host ? true : false}
            />
          </div>

          <div style={{ marginTop: 0 }}>
            <TextField
              name="location"
              id="standard-basic"
              value={formik.values.location}
              label={
                <>
                  <span
                    style={{
                      display: "inline-block",
                      color: "#ff4d4f",
                      fontSize: "14px",
                      fontFamily: "SimSun,sans-serif",
                      lineHeight: 1,
                    }}
                  >
                    *
                  </span>
                  <span> Địa điểm</span>
                </>
              }
              variant="standard"
              sx={{ textAlign: "center", height: "56px", width: "100%" }}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              error={
                formik.errors.location && formik.touched.location ? true : false
              }
            />
          </div>

          <div style={{ marginTop: 0 }}>
            <TextField
              name="preparation"
              id="standard-basic"
              label={<span> Chuẩn bị</span>}
              value={formik.values.preparation}
              variant="standard"
              sx={{ textAlign: "center", height: "56px", width: "100%" }}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              error={false}
            />
          </div>
          <div>
            <label style={{ margin: "5px" }}>Nội dung sự kiện:</label>
            <br />
            <RichEditor
              editorContent={formik.values.event_notice}
              setData={setData}
              placeholder={"Nhập nội dung sự kiện..."}
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <Upload
              valuePropName={"fileList"}
              fileList={fileList}
              multiple={true}
              beforeUpload={() => false}
              onChange={handleChangeFile}
              showUploadList={false}
            >
              <AntButton
                style={{
                  color: "#fff",
                  backgroundColor: "#1677ff",
                  fontSize: "15px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                }}
                icon={<UploadOutlined />}
              >
                Chọn tài liệu đính kèm
              </AntButton>
            </Upload>
          </div>
          <UploadFileListWrapper>
            {fileUploadedList?.map((file, index) => (
              <UploadFileListItem key={file.file_id}>
                <FileTextOutlined />
                <span>{file.file_title}</span>
                <AntButton
                  className={"rename"}
                  type="text"
                  onClick={() => {
                    setIsRenameFileUpdate(true);
                    handleOpenPopupRenameFileUpdate(file, index);
                  }}
                >
                  Đổi tên
                </AntButton>
                <DeleteOutlined
                  onClick={() => handleRemoveFileUpdate(file.file_id, index)}
                />
              </UploadFileListItem>
            ))}
          </UploadFileListWrapper>
          <UploadFileListWrapper>
            {fileList.map((file, index) => (
              <UploadFileListItem key={file.uid || file.id}>
                <FileTextOutlined />
                <span>{file.name}</span>
                <AntButton
                  className={"rename"}
                  type="text"
                  onClick={() => {
                    // setIsRenameFileUpdate(true)
                    handleOpenPopupRenameNewFile(file, index);
                  }}
                >
                  Đổi tên
                </AntButton>
                <DeleteOutlined
                  onClick={() =>
                    handleRemoveFileFromUploadList(file.uid, index)
                  }
                />
              </UploadFileListItem>
            ))}
          </UploadFileListWrapper>
          <div style={{ marginTop: "-8px" }}>
            <TextField
              name="attenders"
              id="standard-basic"
              label={<span> Thành viên tham gia</span>}
              value={formik.values.attenders}
              variant="standard"
              sx={{ textAlign: "center", height: "56px", width: "100%" }}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              error={false}
            />
          </div>
          <div>
            <label>Thông báo:</label>
            <br />
            <TreeSelect
              dropdownStyle={{ zIndex: 100000 }}
              treeDataSimpleMode
              treeData={filterCurrentUserDepartmentList}
              style={{ width: "100%", fontFamily: "SVNGilroy, sans-serif" }}
              showArrow
              allowClear
              showSearch
              filterTreeNode
              treeNodeFilterProp={"name"}
              treeCheckable={true}
              showCheckedStrategy={SHOW_CHILD}
              placeholder={" Người nhận thông báo"}
              onChange={handleChangeRecipientNotice}
              value={value}
            />
          </div>
        </DialogContent>
        <DialogActions
          sx={{ backgroundColor: "#e3e4e9", position: "sticky", bottom: 0 }}
        >
          <Button
            style={{ fontWeight: 600 }}
            onClick={() => {
              handleClose();
              handleResetForm();
            }}
            className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary"
          >
            Đóng
          </Button>
          <Button
            type="submit"
            style={{ fontWeight: 600 }}
            className="uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]"
          >
            {" "}
            Cập nhật
          </Button>
        </DialogActions>
      </form>
      <PopupRenameFile
        isModalVisibleRenameFile={isModalVisibleRenameFile}
        handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={fieldsRenameFile}
        fileExt={fileExt}
      />
    </Dialog>
  );
};

export default memo(
  inject(
    "departmentStore",
    "authenticationStore",
    "loadingAnimationStore",
    "fileStore",
    "workScheduleStore"
  )(observer(CompanyWorkScheduleUpdate))
);
